import React from "react";
import { Row } from "antd";
import styled from "styled-components";
import { Table } from "antd";
import { TableOutlined } from "@ant-design/icons";
import Title from "./Title";

export default function Tables({
  columns = {},
  title = "Report Statistics",
  isHiddenPagination = true,
  summary = null,
}) {
  const { dataKey, defineData } = columns;

  return (
    <RowContainer style={{ marginBottom: "1.5rem" }}>
      <Row className="panel panel-sortable">
        <Title titleName={title}>
          <TableOutlined />
        </Title>
        <div className="container-table__components">
          <Table
            columns={dataKey || []}
            dataSource={defineData || []}
            // scroll={{ x: "auto", y: "auto" }}
            pagination={isHiddenPagination}
            summary={summary}
          />
        </div>
      </Row>
    </RowContainer>
  );
}
const RowContainer = styled.div`
  thead .ant-table-cell {
    border-right: 1px solid #f0f0f0;
  }

  thead .ant-table-cell-fix-right {
    border-bottom: 1px solid #f0f0f0 !important;
  }

  th {
    &::before {
      background-color: inherit !important;
    }
  }

  .panel {
    flex-direction: column;
    position: relative;
    background-color: #fff;
    box-shadow: 0px 0px 13px 0px rgba(62, 44, 90, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.09);
    border-bottom: 1px solid #e0e0e0;
    border-radius: 10px;
    transition: border 500ms ease-out;
    min-height: 200px;
  }

  .container-table__components {
    width: 100%;
    /* overflow: auto; */
  }

  .ant-table {
    width: 100% !important;
    overflow: auto !important;
  }
`;
